export default __webpack_public_path__ + "static/media/chargeback.c05cebfb.png";